export default {
  // Este componente no tiene cadenas estáticas traducibles
  // Usa datos dinámicos pasados desde props
}
